var _path, _path2, _path3, _path4, _g, _circle, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _circle2, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityPrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "training-program",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.829,
    height: 41.037,
    viewBox: "0 0 43.829 41.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_53275",
    "data-name": "Path 53275",
    d: "M25.5,43.759H66.567V70.67H25.5Z",
    transform: "translate(-24.119 -42.147)",
    fill: "#f3f5fb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53276",
    "data-name": "Path 53276",
    d: "M25.5,43.759h5.124V70.67H25.5Z",
    transform: "translate(-24.119 -42.147)",
    fill: "#e5e5ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53277",
    "data-name": "Path 53277",
    d: "M70.57,104.017a.534.534,0,1,1,0-1.069h1.245a.534.534,0,1,1,0,1.069Zm13.178,10.771a.535.535,0,1,1,0,1.069H73.9a.535.535,0,1,1,0-1.069ZM70.57,115.857a.535.535,0,1,1,0-1.069h1.245a.535.535,0,1,1,0,1.069Zm13.178-4.029a.534.534,0,1,1,0,1.069H73.9a.534.534,0,1,1,0-1.069ZM70.57,112.9a.534.534,0,1,1,0-1.069h1.245a.534.534,0,1,1,0,1.069Zm13.178-4.029a.534.534,0,1,1,0,1.069H73.9a.534.534,0,1,1,0-1.069ZM70.57,109.937a.534.534,0,1,1,0-1.069h1.245a.534.534,0,1,1,0,1.069Zm13.178-4.029a.534.534,0,1,1,0,1.069H73.9a.534.534,0,1,1,0-1.069ZM70.57,106.977a.534.534,0,1,1,0-1.069h1.245a.534.534,0,1,1,0,1.069Zm13.178-4.029a.534.534,0,1,1,0,1.069H73.9a.534.534,0,1,1,0-1.069Z",
    transform: "translate(-64.688 -96.063)",
    fill: "#6875b0",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53278",
    "data-name": "Path 53278",
    d: "M11.293,25.665H52.537a1.293,1.293,0,0,1,1.293,1.292V27.6a1.293,1.293,0,0,1-1.293,1.293H11.293A1.293,1.293,0,0,1,10,27.6v-.639a1.293,1.293,0,0,1,1.293-1.292Z",
    transform: "translate(-10.001 -25.665)",
    fill: "#7986bf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45770",
    "data-name": "Group 45770",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53279",
    "data-name": "Path 53279",
    d: "M11.294,28.889h5.213V25.665H11.294A1.3,1.3,0,0,0,10,26.958V27.6A1.3,1.3,0,0,0,11.294,28.889Z",
    transform: "translate(-10.001 -25.665)",
    fill: "#6875b0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53280",
    "data-name": "Path 53280",
    d: "M302.406,108.949A5.921,5.921,0,0,0,299.446,120l1.383-2.395a3.156,3.156,0,0,1,1.578-5.888v-2.765Z",
    transform: "translate(-270.965 -101.53)",
    fill: "#4fe88e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53281",
    "data-name": "Path 53281",
    d: "M362.941,108.95v2.765a3.146,3.146,0,0,1,2.231.924l1.955-1.955A5.9,5.9,0,0,0,362.941,108.95Z",
    transform: "translate(-331.5 -101.531)",
    fill: "#fddb1e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53282",
    "data-name": "Path 53282",
    d: "M389.942,128.415l-1.955,1.955a3.145,3.145,0,0,1,.924,2.231h2.765A5.9,5.9,0,0,0,389.942,128.415Z",
    transform: "translate(-354.315 -119.262)",
    fill: "#fb545c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53283",
    "data-name": "Path 53283",
    d: "M338.587,175.406h-2.765a3.156,3.156,0,0,1-4.733,2.733l-1.383,2.395a5.922,5.922,0,0,0,8.881-5.128Z",
    transform: "translate(-301.225 -162.067)",
    fill: "#009ef9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53284",
    "data-name": "Path 53284",
    d: "M174.794,387.419c3.932,0,7.209,3.789,7.942,8.812H166.852C167.585,391.208,170.861,387.419,174.794,387.419Z",
    transform: "translate(-152.879 -355.193)",
    fill: "#fdc72e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53285",
    "data-name": "Path 53285",
    d: "M200.591,388.772c3.383.681,6.082,4.19,6.739,8.691H193.852C194.508,392.962,197.208,389.453,200.591,388.772Z",
    transform: "translate(-177.474 -356.426)",
    fill: "#fddb1e",
    fillRule: "evenodd"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2682",
    "data-name": "Ellipse 2682",
    cx: 3.622,
    cy: 3.622,
    r: 3.622,
    transform: "translate(16.787 27.076) rotate(-45)",
    fill: "#ffc186"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53286",
    "data-name": "Path 53286",
    d: "M241.214,290.655a3.623,3.623,0,1,1-2.585,3.471A3.624,3.624,0,0,1,241.214,290.655Z",
    transform: "translate(-218.262 -267.049)",
    fill: "#fdd7ad",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53287",
    "data-name": "Path 53287",
    d: "M304.059,387.419c3.932,0,7.209,3.789,7.942,8.812H296.117C296.85,391.208,300.126,387.419,304.059,387.419Z",
    transform: "translate(-270.629 -355.193)",
    fill: "#d93b43",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53288",
    "data-name": "Path 53288",
    d: "M329.856,388.772c3.383.681,6.082,4.19,6.739,8.691H323.117C323.773,392.962,326.473,389.453,329.856,388.772Z",
    transform: "translate(-295.223 -356.426)",
    fill: "#fb545c",
    fillRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2683",
    "data-name": "Ellipse 2683",
    cx: 3.622,
    cy: 3.622,
    rx: 3.622,
    ry: 3.622,
    transform: "translate(29.071 24.37) rotate(-13.3)",
    fill: "#ffc186"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53289",
    "data-name": "Path 53289",
    d: "M370.479,290.655a3.623,3.623,0,1,1-2.585,3.471A3.624,3.624,0,0,1,370.479,290.655Z",
    transform: "translate(-336.012 -267.049)",
    fill: "#fdd7ad",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53290",
    "data-name": "Path 53290",
    d: "M45.529,387.419c3.932,0,7.209,3.789,7.942,8.812H37.587C38.32,391.208,41.6,387.419,45.529,387.419Z",
    transform: "translate(-35.13 -355.193)",
    fill: "#0e82f5",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53291",
    "data-name": "Path 53291",
    d: "M71.326,388.772c3.383.681,6.083,4.19,6.739,8.691H64.587C65.243,392.962,67.943,389.453,71.326,388.772Z",
    transform: "translate(-59.724 -356.426)",
    fill: "#009ef9",
    fillRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2684",
    "data-name": "Ellipse 2684",
    cx: 3.622,
    cy: 3.622,
    r: 3.622,
    transform: "translate(5.273 27.075) rotate(-45)",
    fill: "#ffc186"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53292",
    "data-name": "Path 53292",
    d: "M111.95,290.655a3.623,3.623,0,0,1,0,6.942,3.623,3.623,0,0,1,0-6.942Z",
    transform: "translate(-100.513 -267.049)",
    fill: "#fdd7ad",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityPrograms);
export default __webpack_public_path__ + "static/media/university-programs.1bbe6a43b33d9375275815ac20f4b0e5.svg";
export { ForwardRef as ReactComponent };